// Imports, sempre divididos por lugar onde é importado (React separado do materials e das importações)
import { Button, Checkbox } from "@material-ui/core";
import React, { useEffect, useState } from "react";

// import Grid from "@material-ui/core/Grid";
// import Button from "@material-ui/core/Button";

import Swal from "sweetalert2";

import {
  useCnpj,
  useMarketplace,
} from "../../../context/integracao/MarketplacesContext";
import useMarketPlacesController from "./MarketplacesController";

// CSS da tela
import "./Marketplaces.css";

const MarketplacesTabConfiguracoes = ({ ...props }) => {
  // Constantes de context
  const { marketplace } = useMarketplace();
  const { cnpj } = useCnpj();

  // Constantes de useState
  const [compartilharDadosFiscais, setCompartilharDadosFiscais] =
    useState(false);
  const [construcaoConfiguracao, setConstrucaoConfiguracao] = useState(false);

  // Adiciona as funções vindas de Controllers
  const { atualizarUsuarioConfiguracoes } = useMarketPlacesController();

  // Carrega todos os campos específicos que iniciam com a tela (usando useEffect para serem carregados somente uma vez)

  useEffect(() => {
    // Cada marketplace terá suas configurações
    // Mercado Livre
    if (marketplace && marketplace.id === 5) {
      setCompartilharDadosFiscais(
        marketplace && marketplace.enviar_dados_fiscais
          ? marketplace.enviar_dados_fiscais
          : false
      );
    }
  }, [marketplace]);

  useEffect(() => {
    // Cada marketplace terá suas configurações
    // Mercado Livre
    if (marketplace && marketplace.id === 5) {
      setConstrucaoConfiguracao(
        <div>
          <Button onClick={compartilharDadosFiscaisOnClick}>
            <Checkbox checked={compartilharDadosFiscais} />
            Deseja compartilhar os dados fiscais com os marketplaces? (somente
            para simples nacional)
          </Button>
        </div>
      );
    }
    // eslint-disable-next-line
  }, [compartilharDadosFiscais]);

  // Function dos botões

  const compartilharDadosFiscaisOnClick = () => {
    setCompartilharDadosFiscais((value) => !value);
  };

  const salvarOnClick = async () => {
    let retorno = await atualizarUsuarioConfiguracoes(
      cnpj,
      marketplace.id,
      compartilharDadosFiscais
    );

    if (retorno && retorno.ativo) {
      marketplace.enviar_dados_fiscais = compartilharDadosFiscais;

      Swal.fire({
        icon: "success",
        title: "Configurações salvas com sucesso!",
        timer: 2500,
        showConfirmButton: false,
      });
    }
  };

  // Construção da tela

  return (
    <>
      <h3>{marketplace ? marketplace.descricao : ""}</h3>
      {construcaoConfiguracao}
      <div style={{ marginTop: 15 }}>
        <Button color="primary" variant="contained" onClick={salvarOnClick}>
          Salvar
        </Button>
      </div>
    </>
  );
};

export default MarketplacesTabConfiguracoes;
